module.exports = __webpack_public_path__ + "img/ic_64_achievement_spieltagssieg.30eb2809.svg";